import { getStatusColor, getStatusLabel } from "./config/constants/status";

export default function ImportCnfBillStatusTag({ status }) {
  const label = getStatusLabel(status);
  const backgroundColor = getStatusColor(status);

  return (
    <span
      style={{
        display: "inline-block",
        color: "#fff",
        backgroundColor,
        padding: "2px 10px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: "22px",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}
